// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".polygon-icon{fill:var(--primary-text-color);stroke:var(--primary-text-color)}", "",{"version":3,"sources":["webpack://./src/components/icons/PolygonIcon.scss"],"names":[],"mappings":"AAAA,cACE,8BAAA,CACA,gCAAA","sourcesContent":[".polygon-icon {\n  fill: var(--primary-text-color);\n  stroke: var(--primary-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
